export default __webpack_public_path__ + "static/media/TargetedContentDefault.f55d77d1.jpg";